import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController } from 'ionic-angular';
import {AppState} from '../../../app/app.global';
import {ServicehomePage} from '../servicehome/servicehome';

import { HttpService } from '../../../providers/service/httpservice';
import { StorageService } from '../../../providers/service/storageservice';
import { SERVICE_SAVE_COLLECTAPP,SERVICE_SELECT_MYCOLLECT} from '../../../providers/config/serviceurl';


@Component({
  selector: 'page-serviceedit',
  templateUrl: 'serviceedit.html',
})
export class ServiceeditPage {
  resourceUrl = "";//资源服务器ip和端口号
  user:any={};
  saveAppIdlist = [];
  myserviceImgList:any=[];
  serviceList:any = [];
  callback;
  constructor(public navCtrl: NavController, public navParams: NavParams, public global:AppState,private alertCtrl: AlertController,private httpService:HttpService) {
    this.user = StorageService.getObj('currentUser');
    this.resourceUrl = StorageService.getObj('resourceUrl') + "/";
    this.loadMyserviceList();
    this.serviceList = navParams.data.serviceList;
    this.callback = this.navParams.get("callback");
  }

    //加载我的服务列表
    loadMyserviceList(){
      let params = {'username':this.user.xgh,'pageNo':0,'pageSize':5,'loadAll':true};
      this.httpService.get2(SERVICE_SELECT_MYCOLLECT,params).then(anyObj =>this.handleLoadMyserviceList(anyObj));
    }

    handleLoadMyserviceList(obj:any){
      if(obj != null && obj != undefined){
        this.myserviceImgList = obj.items;
        if(this.myserviceImgList.constructor == Array){
         //缓存AppId
         for (let index = 0; index < this.myserviceImgList.length; index++) {
           const element = this.myserviceImgList[index];
           this.saveAppIdlist.push(element.ID);
          }
        }
        this.setMaxHight();
      }
    }

  editComplete(){
    if(this.saveAppIdlist.constructor == Array &&  this.saveAppIdlist.length > 0){
      let dataAppItem:string  = this.saveAppIdlist.join(",");
      let params = {'username':this.user.xgh,'ids':dataAppItem};
    this.httpService.post2(SERVICE_SAVE_COLLECTAPP,params).then(anobj=>{
    //返回首页
    let param = 'serviceedit';
   this.callback(param).then(()=>{
    this.navCtrl.pop();
    });
    });
    }

    
  }
  

  //删除
  deleteService(event:any, item:any){
    if(this.saveAppIdlist.indexOf(item.ID) > -1){
      const num = this.saveAppIdlist.indexOf(item.ID);
      this.saveAppIdlist.splice(num,1);
      this.myserviceImgList.splice(num,1);
      this.setMaxHight();
    }
  }

  //添加到我的服务
  addService(event:any, item:any){
    if(this.saveAppIdlist.indexOf(item.ID) > -1){
      let alert = this.alertCtrl.create({
        subTitle: '请勿重复添加',
        buttons: ['确定']
      });
      alert.present();
      return;
    }
    
    this.saveAppIdlist.push(item.ID);
    this.myserviceImgList.push(item);
    this.setMaxHight();
  }

  //控制服务列表高度
  setMaxHight(){
   //扩展页面固定标题栏尺寸
   let height=37;
   let multiple =  0;
   if(this.saveAppIdlist.length % 4 == 0){
    multiple = this.saveAppIdlist.length / 4;
   }else{
    multiple = this.saveAppIdlist.length / 4 + 1;
   }
   height = height + multiple * 80;
   document.getElementById("pListScrollModel").style.top = height + "px";
  }

}



// WEBPACK FOOTER //
// ./src/pages/service/serviceedit/serviceedit.ts